export default __webpack_public_path__ + "static/media/ss.7dc4ae24.jpeg";